import { useState } from "react";
import FeaturedActiveVideoCard from "@routes/Videos/VideosPage/components/FeaturedVideoPlaylist/FeaturedActiveVideoCard";
import FeaturedVideoPlaylistPagination from "@routes/Videos/VideosPage/components/FeaturedVideoPlaylist/FeaturedVideoPlaylistPagination";
import { VideoCardProps } from "@routes/Videos/VideosPage/utils/types";

type FeaturedVideoPlaylistProps = {
  /** This is the list of videos to be displayed. */
  videos: VideoCardProps[];
};

/**
 * This is the component for displaying the featured video playlist.
 */
const FeaturedVideoPlaylist = ({ videos }: FeaturedVideoPlaylistProps) => {
  const [activeVideo, setActiveVideo] = useState<VideoCardProps>(videos[0]);

  return (
    <div data-testid="featured-video-playlist-component">
      <FeaturedActiveVideoCard video={activeVideo} />

      <FeaturedVideoPlaylistPagination
        videos={videos}
        activeVideo={activeVideo}
        setActiveVideo={setActiveVideo}
      />
    </div>
  );
};

export default FeaturedVideoPlaylist;
